// eslint-disable-next-line import/no-extraneous-dependencies
import faker from 'faker';
import { Factory } from 'miragejs';
import { v4 as uuidv4 } from 'uuid';
import { TimeUtil } from '@/util/time';

export default Factory.extend({
  bookingChannelId: '2590b362-4937-420a-b810-d90ef0dd010f',
  createdBy: uuidv4(),
  givenName() {
    return faker.name.firstName();
  },
  familyName() {
    return faker.name.lastName();
  },
  email() {
    return faker.internet.email();
  },
  roles: [{
    name: 'fleetAdmin',
  }],
  status: 'active',
  communicationLanguage: 'en',
  product: 'customer',
  fleetId: '8a7d2e09-fb66-4e3c-9cfb-09852d9abdea',
  createdAt: TimeUtil.now().toISOString(),
  updatedAt: TimeUtil.now().toISOString(),
});
